// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  margin-top: 10px;
}

.logo {
  max-width: 100%;
  max-height: 64px;
  object-fit: contain;
}

.info {
  font-size: 12px;
  margin-top: 5px;
  text-align: center;
}

.az-sidebar {
  padding-top: 10px;
}

.az-footer {
  background-color: white !important;
  position: fixed;
  bottom: 10px;
  width: 239px;
}

.username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 130px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;;AAAA;EACI,eAAA;EACA,eAAA;EACA,kBAAA;AAGJ;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACI,kCAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAGJ;;AAAA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAGJ","sourcesContent":[".footer {\n    margin-top: 10px\n}\n.logo {\n    max-width:100%;\n    max-height:64px;\n    object-fit: contain;\n}\n.info {\n    font-size: 12px;\n    margin-top: 5px;\n    text-align: center;\n}\n\n.az-sidebar {\n  padding-top: 10px;\n}\n\n.az-footer {\n    background-color: white !important;\n    position:fixed;\n    bottom: 10px;\n    width: 239px; \n}\n\n.username {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    width: 130px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
